import { Image } from "@mantine/core";
import {
  formatDateTime,
  formatDateTransfer,
} from "../../../../../common/FormatDate/FormatDate";
import { IconMail, IconPhone, IconWorldWww } from "@tabler/icons-react";

type Props = {
  componentRef: any;
  dataPrint: any;
};

const PrintXDCCNSerial = ({ componentRef, dataPrint }: Props) => {
  // console.log("dataPrint", dataPrint);
  const dataTransaction = dataPrint?.tblInventoryTransactionModel;
  const dataSerials = dataPrint?.inventoryTransactionSerialModels;

  const useLoginHeader = JSON.parse(
    localStorage.getItem("userLoginHeader") || "{}"
  );

  //LẤY TÊN THÀNH PHỐ
  const getCityFromAddress = (address: string) => {
    if (!address) return ""; // Trường hợp address bị null hoặc undefined
    const parts = address?.split(" - ");
    return parts[parts.length - 1]; // Lấy phần cuối cùng làm tên thành phố
  };
  return (
    <div
      ref={componentRef}
      style={{
        height: "100%",
        margin: "0 auto",
        marginLeft: "40px",
        marginRight: "30px",
        // marginTop: "10px",
        fontFamily: `"Times New Roman", Times, serif`,
        position: "relative",
      }}
    >
      <div
        style={{
          // paddingTop: "10px",
          width: "100%",
          position: "relative",
          margin: "0 auto",
          marginRight: "20px",
          paddingRight: "20px",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "grid",
            gridTemplateColumns: "2fr 1.5fr 2fr",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <h6 style={{ margin: 0, fontSize: "10px", fontWeight: 600 }}>
              {useLoginHeader?.companyCode === "DVT"
                ? "Công Ty Cổ Phần HACOM Dịch Vụ Tốt"
                : " Công Ty Cổ Phần Đầu Tư Công Nghệ HACOM"}
            </h6>
            <p style={{ margin: 0, fontSize: "9px" }}>
              {/* CN: 129 Lê Thanh Nghị, P. Đồng Tâm, Q. Hai Bà Trưng, TP. Hà Nội */}
              CN: {dataTransaction?.fromBranchAddress}
            </p>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "3px",
                alignItems: "center",
                fontSize: "10px",
                marginTop: "-5px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "3px",
                }}
              >
                <IconPhone
                  stroke={2}
                  style={{
                    width: "10px",
                  }}
                />
                <p style={{ margin: 0, fontSize: "10px" }}>
                  {useLoginHeader?.companyCode === "DVT"
                    ? "18008091"
                    : "19001903"}
                  {" |"}
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "3px",
                }}
              >
                <IconMail
                  stroke={2}
                  style={{
                    width: "10px",
                  }}
                />
                <p style={{ margin: 0, fontSize: "10px" }}>
                  {useLoginHeader?.companyCode === "DVT"
                    ? "info@dichvutot.vn"
                    : "dichvukhachhang@hacom.vn"}
                  {" |"}
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "3px",
                }}
                // className={styles.text}
              >
                <IconWorldWww
                  stroke={2}
                  style={{
                    width: "10px",
                  }}
                />
                <p style={{ margin: 0, fontSize: "10px" }}>
                  {useLoginHeader?.companyCode === "DVT"
                    ? "dichvutot.vn"
                    : "Hacom.vn"}
                </p>
              </div>
            </div>
          </div>
          <div style={{ paddingTop: "15px" }}>
            <h1
              style={{
                fontWeight: "700",
                lineHeight: "1",
                fontSize: "18px",
                textAlign: "center",
                alignItems: "center",
                margin: 0,
              }}
            >
              PHIẾU XUẤT KHO
            </h1>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-end",
                gap: "3px",
                fontSize: "12px",
              }}
              // className={styles.warehouseCode}
            >
              <p
                style={{
                  fontSize: "12px",
                  fontWeight: 400,
                  margin: 0,
                }}
              >
                Mã Xuất Kho:{" "}
              </p>{" "}
              {dataTransaction?.transactionCode}
            </div>
            <div
              // className={styles.warehouseCode}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-end",
                gap: "3px",
                fontSize: "12px",
              }}
            >
              <p
                style={{
                  fontSize: "12px",
                  fontWeight: 400,
                  margin: 0,
                }}
              >
                Mã Yêu Cầu Xuất Kho:{" "}
              </p>
              {dataTransaction?.sourceCode}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                width: "100%",
                fontSize: "14px",
              }}
            >
              <div>
                {getCityFromAddress(dataTransaction?.fromBranchAddress)} ngày{" "}
                <strong style={{ fontStyle: "italic" }}>
                  {formatDateTime(dataTransaction?.finishDate)}
                </strong>{" "}
              </div>
            </div>
          </div>
        </div>
        <table
          style={{
            marginTop: "10px",
            width: "100%",
            borderCollapse: "collapse",
            // border: "1px solid black",
            marginBottom: "10px",
          }}
        >
          <thead>
            <tr>
              <th style={{ width: "16%", border: "none" }}></th>
              <th style={{ width: "42%", border: "none" }}>BÊN XUẤT</th>
              <th style={{ width: "42%", border: "none" }}>BÊN NHẬN</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                style={{
                  whiteSpace: "nowrap",
                }}
              >
                Phòng ban
              </td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  border: "1px solid black",
                  paddingLeft: "4px",
                }}
              >
                {dataTransaction?.fromBranchName}
              </td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  border: "1px solid black",
                  paddingLeft: "4px",
                }}
              >
                {dataTransaction?.toBranchName}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  whiteSpace: "nowrap",
                }}
              >
                Địa điểm làm việc
              </td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  border: "1px solid black",
                  paddingLeft: "4px",
                }}
              >
                {dataTransaction?.fromBranchAddress}
              </td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  border: "1px solid black",
                  paddingLeft: "4px",
                }}
              >
                {dataTransaction?.toBranchAddress}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  whiteSpace: "nowrap",
                }}
              >
                Bộ phận
              </td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  border: "1px solid black",
                  paddingLeft: "4px",
                }}
              >
                {dataTransaction?.departmentName}
              </td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  border: "1px solid black",
                  paddingLeft: "4px",
                }}
              ></td>
            </tr>
            <tr>
              <td
                style={{
                  whiteSpace: "nowrap",
                }}
              >
                Chức danh
              </td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  border: "1px solid black",
                  paddingLeft: "4px",
                }}
              >
                {dataTransaction?.createRoleName}
              </td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  border: "1px solid black",
                  paddingLeft: "4px",
                }}
              ></td>
            </tr>
            <tr>
              <td
                style={{
                  whiteSpace: "nowrap",
                }}
              >
                Họ & Tên
              </td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  border: "1px solid black",
                  paddingLeft: "4px",
                }}
              >
                {dataTransaction?.createName
                  ? dataTransaction?.createName
                  : // +
                    //   " - " +
                    //   dataTransaction?.createCode
                    ""}
              </td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  border: "1px solid black",
                  paddingLeft: "4px",
                }}
              ></td>
            </tr>
            <tr>
              <td
                style={{
                  whiteSpace: "nowrap",
                }}
              >
                Kho
              </td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  border: "1px solid black",
                  paddingLeft: "4px",
                }}
              >
                {`${dataTransaction?.fromInvCode ?? ""}-${
                  dataTransaction?.fromInvName ?? ""
                }`}
              </td>
              <td
                style={{
                  whiteSpace: "nowrap",
                  border: "1px solid black",
                  paddingLeft: "4px",
                }}
              >
                {`${dataTransaction?.toInvCode ?? ""}-${
                  dataTransaction?.toInvName ?? ""
                }`}
              </td>
            </tr>
          </tbody>
        </table>
        {/* LÝ DO */}
        <div style={{ margin: "5px 0" }}>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <p style={{ margin: 0, marginRight: "5px" }}>Lý do:</p>
            <p style={{ margin: 0 }}>
              {dataTransaction?.sourceType === "XUAT_DIEU_CHUYEN_CHI_NHANH"
                ? "Xuất điều chuyển chi nhánh"
                : dataTransaction?.sourceType ===
                  "XUAT_DIEU_CHUYEN_CHI_NHANH_SERIAL"
                ? "Xuất điều chuyển chi nhánh serial"
                : dataTransaction?.sourceType === "XUAT_DIEU_CHUYEN_NOI_BO"
                ? "Xuất điều chuyển nội bộ"
                : dataTransaction?.sourceType ===
                  "XUAT_DIEU_CHUYEN_NOI_BO_SERIAL"
                ? "Xuất điều chuyển nội bộ serial"
                : ""}
            </p>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "5px",
            }}
          >
            <p style={{ margin: 0 }}>Ghi chú:</p>
            <p style={{ margin: 0 }}>{dataTransaction?.description}</p>
          </div>
        </div>
        {/* table product */}
        <div
          // className={styles.ProductTable}
          style={{
            marginTop: "10px",
            width: "100%",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              border: "1px solid black",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: "1px solid black",
                  }}
                  rowSpan={2}
                  scope="col"
                >
                  STT
                </th>
                <th
                  style={{
                    border: "1px solid black",
                  }}
                  rowSpan={2}
                  scope="col"
                >
                  Mã hàng
                </th>
                <th
                  style={{
                    border: "1px solid black",
                  }}
                  rowSpan={2}
                  scope="col"
                >
                  Serial
                </th>
                <th
                  style={{
                    border: "1px solid black",
                  }}
                  rowSpan={2}
                  scope="col"
                >
                  Tên sản phẩm
                </th>
                <th
                  style={{
                    border: "1px solid black",
                  }}
                  rowSpan={2}
                  scope="col"
                >
                  ĐVT 1
                </th>
                <th
                  style={{
                    border: "1px solid black",
                  }}
                  rowSpan={2}
                  scope="col"
                >
                  SL 1
                </th>
                <th
                  style={{
                    border: "1px solid black",
                  }}
                  colSpan={2}
                  scope="col"
                >
                  Quy đổi
                </th>
                <th
                  style={{
                    border: "1px solid black",
                  }}
                  rowSpan={2}
                  scope="col"
                >
                  Tình trạng
                </th>
                <th
                  style={{
                    border: "1px solid black",
                  }}
                  rowSpan={2}
                  scope="col"
                >
                  Ghi chú
                </th>
              </tr>
              <tr>
                <th
                  scope="col"
                  style={{
                    border: "1px solid black",
                  }}
                >
                  SL2
                </th>
                <th
                  scope="col"
                  style={{
                    border: "1px solid black",
                  }}
                >
                  ĐVT 2
                </th>
              </tr>
            </thead>
            <tbody>
              {dataSerials?.map((item: any, index: number) => {
                return (
                  <tr key={index}>
                    <td
                      style={{
                        border: "1px solid black",
                        textAlign: "center",
                      }}
                    >
                      {index + 1}
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        padding: "0 2px",
                      }}
                    >
                      {item?.itemCode}
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        textAlign: "left",
                        padding: "0 2px",
                      }}
                    >
                      {item?.serial}
                    </td>
                    <td
                      style={{
                        textAlign: "start",
                        border: "1px solid black",
                        paddingLeft: "3px",
                      }}
                    >
                      {item?.itemName}
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        textAlign: "center",
                      }}
                    >
                      {item?.primaryUomCode}
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        padding: "0 2px",
                      }}
                    >
                      {item?.primaryQuantity}
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        padding: "0 2px",
                      }}
                    >
                      {item?.subQuantity}
                    </td>{" "}
                    <td
                      style={{
                        border: "1px solid black",
                        padding: "0 2px",
                      }}
                    >
                      {item?.subUom}
                    </td>{" "}
                    <td
                      style={{
                        border: "1px solid black",
                        padding: "0 2px",
                      }}
                    >
                      {item?.serialStatus}
                    </td>{" "}
                    <td
                      style={{
                        border: "1px solid black",
                        padding: "0 2px",
                      }}
                    >
                      {item?.note}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            width: "100%",
            margin: "0 auto",
            marginTop: "10px",
          }}
        >
          <div
            style={{
              textAlign: "center",
            }}
          >
            <p style={{ fontWeight: "700" }}>BÊN XUẤT</p>
            <div
              style={{
                marginTop: "50px",
              }}
            >
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                {dataTransaction?.createName}
              </p>
            </div>
          </div>
          <div
            style={{
              textAlign: "center",
            }}
          >
            {/* <p style={{ fontWeight: "700" }}>GIAO VẬN</p> */}
          </div>
          <div
            style={{
              textAlign: "center",
            }}
          >
            <p style={{ fontWeight: "700" }}>BÊN NHẬN</p>
          </div>
        </div>
      </div>
      <div
        // className={styles.backgroudHacom}
        style={{
          position: "absolute",
          width: "100%",
          zIndex: -1,
          opacity: 0.1,
          top: "40%",
        }}
      >
        <Image
          radius="md"
          src="https://hanoicomputercdn.com/media/lib/17-10-2024/logo-hacom-since-2001_new.png"
          // className={styles.logo}
          style={{
            width: "90%",
            margin: "0 auto",
          }}
        />
      </div>
    </div>
  );
};

export default PrintXDCCNSerial;
